module.exports = __webpack_public_path__ + "media/images/favicon-0a5cadbfb8667ba19705383ec5d586f3.png";